// Auto-generated list of MUI icons
// This file contains all available Material-UI icons

import * as MuiIcons from '@mui/icons-material';
import React from 'react';

export interface MuiIconDefinition {
  name: string;
  component: React.ComponentType<any>;
  keywords: string[];
}

// Function to generate the icons list
const generateIconsList = (): MuiIconDefinition[] => {
  const iconNames = Object.keys(MuiIcons);
  
  return iconNames
    .filter((key) => {
      // Filter out non-icon exports
      const value = (MuiIcons as any)[key];
      const isValid = key !== 'default' && 
                     key !== '__esModule' && 
                     typeof value === 'object' && 
                     value !== null;
      return isValid;
    })
    .map((iconName) => {
      // Generate keywords from icon name for better search
      const keywords = iconName
        .replace(/([A-Z])/g, ' $1') // Add space before capital letters
        .toLowerCase()
        .split(' ')
        .filter(Boolean);

      return {
        name: iconName,
        component: (MuiIcons as any)[iconName],
        keywords,
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));
};

// Create a searchable list of all MUI icons
export const muiIconsList: MuiIconDefinition[] = generateIconsList();

// Helper to get icon component by name
export const getIconByName = (iconName: string): React.ComponentType<any> | null => {
  const icon = muiIconsList.find((icon) => icon.name === iconName);
  return icon ? icon.component : null;
};

// Export total count for debugging
export const totalMuiIcons = muiIconsList.length;
